var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.555664 13C0.555664 6.12711 6.12723 0.555542 13.0001 0.555542C16.3006 0.555542 19.4659 1.86665 21.7997 4.20044C24.1334 6.53422 25.4446 9.69951 25.4446 13C25.4446 19.8729 19.873 25.4444 13.0001 25.4444C6.12723 25.4444 0.555664 19.8729 0.555664 13ZM12.6392 17.6169L18.8614 11.3947C19.3494 10.9067 19.3494 10.1155 18.8614 9.62754C18.3735 9.13957 17.5823 9.13957 17.0943 9.62754L11.7557 14.9787L8.90589 12.1164C8.59022 11.8008 8.13013 11.6775 7.69893 11.793C7.26772 11.9086 6.93091 12.2454 6.81537 12.6766C6.69983 13.1078 6.82311 13.5679 7.13878 13.8835L10.8721 17.6169C11.1058 17.8525 11.4238 17.985 11.7557 17.985C12.0875 17.985 12.4056 17.8525 12.6392 17.6169Z",
    fill: "#1B1D21"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.2bee204bbb6b87c44dadd591c11696eb.svg";
export { ForwardRef as ReactComponent };